import { Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export default class ContactDetail extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Rules.StringLength(50)
    public firstName: string = "";

    @Rules.Required()
    public titleId: number | null = null;

    @Rules.Required()
    @Rules.StringLength(50)
    public lastName: string = "";

    @Rules.StringLength(100)
    public phoneNo: string = "";

    @Rules.StringLength(100)
    public secondaryPhoneNo: string = "";

    @Rules.Required()
    @Rules.EmailAddress()
    @Rules.StringLength(100)
    public emailAddress: string = "";

    // Client only properties / methods

    public get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Contact Detail";
    }
}